import { AppLink, LanguageSelect } from "@/shared/Components";
import { peopleLanding } from "@/shared/constants/umarta-links";
import { installationConfig } from "@/shared/constants/installation-config";
import type { FC, PropsWithChildren } from "react";
import { getLogo } from "../../helpers/getLogo";
import styles from "./styles.module.scss";

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <AppLink href={peopleLanding} target="_blank">
          {getLogo()}
        </AppLink>
        {installationConfig.name === "Umarta" && (
          <LanguageSelect
            className={styles["language-select"]}
            rootClassName={styles["language-select-options"]}
          />
        )}
      </div>
      <div className={styles["content-wrapper"]}>{children}</div>
    </div>
  );
};
